import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import "../../assets/css/datatables/responsive.dataTables.min.css";
import jwt_decode from "jwt-decode";
import {css} from "@emotion/core";
import loadingGif from "../../assets/img/loading.gif";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
function formatNumber (num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
function format(rowData, row) {

    var childTable = '<table id="cl' + row.index() + '" class="display compact nowrap w-100" width="100%">' +
        '<thead style="display:none"></thead >' +
        '</table>';
    return $(childTable).toArray();
}
class TransactionSummary extends Component{
    constructor(props) {
        super(props);
        this.state={
            table:{},
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            monthID: '042020',
            user_id:'',
            is_download: true,
            merchant_name: 'Reliance Retail Limited',
            stable: {}
        }
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.get_filtered_data_merchant('', '', '', this.state.monthID);
        }
        else if(decoded.object_type=='Merchant') {
            this.get_filtered_data_merchant('', arrayCode, '', this.state.monthID);
        }
        else if(decoded.object_type=='Chain') {
            this.get_filtered_data_merchant('', arrayCode, '', this.state.monthID);
        }
        else if(decoded.object_type=='Store') {
            this.get_filtered_data_merchant('', '', arrayCode, this.state.monthID);

        }
    }
    get_filtered_data_merchant(mid,cid,sid,month){
        var childTable;
        $('#MerchantSummaryTable').html('');
        let postdataBank = {
            merchant_codes: mid,
            chain_codes: cid,
            store_codes: sid,
            month: month
        };

        let total = '';
        let pageTotal = '';
        var merchantDataTable = '';
        if ($.fn.DataTable.isDataTable('#MerchantSummaryTable')) {
            $('#MerchantSummaryTable').DataTable().clear().destroy();
        }

        var merchantSummaryDataTable = $('#MerchantSummaryTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "bInfo": false,
                "paging": true,
                "pageLength": 20,
                "autoWidth": false,
                "responsive": false,
                "searching": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/merchant_summary_details",
                    type: 'POST',
                    data: postdataBank,
                    dataSrc:function ( json ) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                aoColumns: [

                    {sTitle: "Billing Company", mData: "Billing Company"},
                    {sTitle: "Merchant", mData: "Merchant"},
                    {sTitle: "Chain", mData: "Chain"},
                    {sTitle: "Store", mData: "Store"},
                    {sTitle: "GST", mData: "GST"},
                    {sTitle: "State Name", mData: "State"},
                    {sTitle: "Total Amount", mData: "Total Amount"},
                    {sTitle: "", mData: "invoice_detail_id"},
                ],
                columns: [

                    {"data": "Billing Company"},
                    {"data": "Merchant"},
                    {"data": "Chain"},
                    {"data": "Store"},
                    {"data": "GST"},
                    {"data": "State"},
                    {"data": "Total Amount"},
                    {"data": "invoice_detail_id"},
                ],
                "columnDefs": [
                    {
                        "width": "15%",
                        render: function (data) {
                            return '<td ><div class="collapseFirstTD"><a href="#">' + data + '</a> &nbsp;</div></td>';
                        },
                        className: "summary_plus g_level",
                        targets: 0,
                        aTargets: [-1]
                    },

                    {
                        render: function (data) {
                            return '<td > &nbsp;</td>';
                        },
                        "width": "15%",
                        "targets": [1,2,3,4],

                    },

                    {
                        render: function (data) {
                            return '<td > &nbsp;</td>';
                        },
                        "width": "12%",
                        "targets": [5],

                    },
                    {
                        render: function (data) {
                            return data;
                        },
                        "width": "12%",
                        "targets":6,
                        "className": "text-right"
                    },


                    {
                        "width": "0.1%",
                        render: function (data) {
                            return '<td ></td>';
                        },
                        targets: 7,
                        aTargets: [-1]
                    },
                ],
                // "footerCallback": function ( row, data, start, end, display ) {
                //     var api = this.api(), data;
                //
                //     // Remove the formatting to get integer data for summation
                //     var intVal = function ( i ) {
                //         return typeof i === 'string' ?
                //             i.replace(/[\$,]/g, '')*1 :
                //             typeof i === 'number' ?
                //                 i : 0;
                //     };
                //
                //     // Total over all pages
                //     total = api
                //         .column( 3 )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //     let totalCount = api
                //         .column( 3 )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //
                //     // Total over this page
                //     pageTotal = api
                //         .column( 3, { page: 'current'} )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //     let pageTotalCount = api
                //         .column( 2, { page: 'current'} )
                //         .data()
                //         .reduce( function (a, b) {
                //             return intVal(a) + intVal(b);
                //         }, 0 );
                //
                //     // Update footer
                //     $( api.column( 3 ).footer() ).html(
                //         ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                //     );
                //     $( api.column( 2 ).footer() ).html(
                //         ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                //     );
                // },

            });

        this.setState({
            stable: merchantSummaryDataTable
        });

        $('#MerchantSummaryTable').on('click', 'td.g_level', function (e) {
            e.preventDefault();
            var tr = $(this).closest('tr');
            var row = merchantSummaryDataTable.row(tr);
            var rowData = row.data();
            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            } else {
                // Open this row
                if (row.data() != undefined) {
                    row.child(format(rowData, row)).show();
                    //var bill_company_name = row.data()["Billing Company Name"];
                    //var invoice_detail_id = row.data()["Billing Company"];
                    //alert(invoice_detail_id);
                    var content = '';
                    // var loadingImg = "<div style='text-align: left'><img src=" + loadingGif + "></div>";
                    // row.child(loadingImg).show();
                    let postGdata = {
                        merchant_codes: mid,
                        chain_codes: cid,
                        store_codes: sid,
                        month: month,
                        billing_company_name: row.data()["Billing Company"]
                    };
                    childTable = $('#cl' + row.index()).DataTable({
                        dom: "t",
                        ajax: {
                            url: config.get('API_URL') + "/invoice/merchant_summary_gn_view",
                            type: 'POST',
                            data: postGdata,
                            dataSrc: function (json) {
                                return json.data;
                            },
                            beforeSend: function (request) {
                                request.setRequestHeader("Authorization", localStorage.usertoken);
                            },
                        },
                        aoColumns: [

                            {sTitle: "Billing Company", mData: "Billing Company"},
                            {sTitle: "Merchant", mData: "Merchant"},
                            {sTitle: "Chain", mData: "Chain"},
                            {sTitle: "Store", mData: "Store"},
                            {sTitle: "GST", mData: "GST"},
                            {sTitle: "State Name", mData: "State"},
                            {sTitle: "Total Amount", mData: "Total Amount"},
                            {sTitle: "", mData: "invoice_detail_id"},
                        ],
                        columns: [

                            {"data": "Billing Company"},
                            {"data": "Merchant"},
                            {"data": "Chain"},
                            {"data": "Store"},
                            {"data": "GST"},
                            {"data": "State"},
                            {"data": "Total Amount"},
                            {"data": "invoice_detail_id"},
                        ],
                        "columnDefs": [
                            {
                                "width": "15%",
                                render: function (data) {
                                    return '<td ><div class="collapseFirstTD"><a href="#">' + data + '</a> &nbsp;</div></td>';
                                },
                                className: "summary_plus1 summary_gn1nth",
                                targets: 0,
                                aTargets: [-1]
                            },

                            {
                                render: function (data) {
                                    return data;
                                },
                                "width": "15%",
                                className: "summary_gn",
                                "targets": [1, 2, 3, 4],

                            },

                            {
                                render: function (data) {
                                    return data;
                                },
                                "width": "12%",
                                className: "summary_gn_12",
                                "targets": [5],

                            },
                            {
                                render: function (data) {
                                    return data;
                                },
                                "width": "12%",

                                "targets": 6,
                                "className": "text-right summary_gn_12"
                            },


                            {
                                "width": "0.1%",
                                render: function (data) {
                                    return '<td ></td>';
                                },
                                className: "summary_gn_1",
                                targets: 7,
                                aTargets: [-1]
                            },

                        ],
                        select: false,
                    });

                    tr.addClass('shown');
                    $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                    $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
                }
            }

            });
        $('#MerchantSummaryTable tbody').on('click', 'td.summary_gn1nth', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var tr = $(this).closest('tr');
            var row = childTable.row(tr);
            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus1').addClass('summary_plus1');
                $(this).closest('tr').find('.summary_minus1').removeClass('summary_minus1');
            } else {
                // Open this row
                if (row.data() != undefined) {
                    //var bill_company_name = row.data()["Billing Company Name"];
                    var invoice_detail_id = row.data()["invoice_detail_id"]; //alert(invoice_detail_id);
                    var content = '';
                    var loadingImg = "<div style='text-align: left'><img src=" + loadingGif + "></div>";
                    row.child(loadingImg).show();
                    $.ajax({
                        type: 'GET',
                        url: config.get('API_URL') + "/invoice/merchant_summary_state_details?invoice_detail_id=" + invoice_detail_id+"&party=merchant",
                        beforeSend: function (request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            content = '<table id="innerTableBankSummury" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            content = content + '<tr>';
                            content = content + '<th style="width:5%">Serial No </th>';
                            content = content + '<th style="width:35%">Description of Services </th>';
                            content = content + '<th style="width:20%">HSN/SAC</th>';
                            content = content + '<th style="width:10%">Quantity </th>';
                            content = content + '<th style="width:10%">Rate </th>';
                            content = content + '<th style="width:10%">Per</th>';
                            content = content + '<th style="width:10%">Amount </th>';
                            content = content + '</tr>';
                            data.data.map((value, index) => {
                                var sno = "";
                                var des = "";
                                var hsn = "";
                                var hsn = "";
                                var qun = "";
                                var rate = "";
                                var per = "";
                                var amt = "";
                                if (value["Serial No"] === null || value["Serial No"] == 'null') {
                                    sno = "";
                                } else {
                                    sno = value["Serial No"];
                                }

                                if (value["Description of Services"] === null || value["Description of Services"] == 'null') {
                                    des = "";
                                } else {
                                    des = value["Description of Services"];
                                }
                                if (value["HSN/SAC"] === null || value["HSN/SAC"] == 'null') {
                                    hsn = "";
                                } else {
                                    hsn = value["HSN/SAC"];
                                }
                                if (value["Quantity"] === null || value["Quantity"] == 'null') {
                                    qun = "";
                                } else {
                                    qun = value["Quantity"];
                                }
                                if (value["Rate"] === null || value["Rate"] == 'null') {
                                    rate = "";
                                } else {
                                    rate = value["Rate"];
                                }
                                if (value["Per"] === null || value["Per"] == 'null') {
                                    per = "";
                                } else {
                                    per = value["Per"];
                                }
                                if (value["Amount"] === null || value["Amount"] == 'null') {
                                    amt = "";
                                } else {
                                    amt = value["Amount"];
                                }
                                //var align = "left";
                                var ma_left = "0px";
                                //if (value["description_alignment"] == 'left') {
                                var align = value["description_alignment"];
                                //     ma_left = "0px";
                                // } else {
                                //     align = "right";
                                //     ma_left = "20px";
                                // }
                                var font = "normal";
                                if (value["text_type"] == 'bold') {
                                    font = "bold";
                                }

                                var countSpace = des.search(/\S/);
                                var spa = '';
                                for (var i = 0; i <= countSpace; i++) {
                                    spa += '&nbsp;'
                                }
                                //console.log(spa);
                                content = content + '<tr>';
                                content = content + '<td style="width:5%; border-right:1px solid #ddd!important; border-bottom:0px solid #ddd;">' + sno + ' </td>';
                                content = content + '<td style="width:20%; border-right:1px solid #ddd!important; border-bottom:0px solid #ddd; text-align: ' + align + ';  font-weight: ' + font + ';">' + spa + des + ' </td>';
                                content = content + '<td style="width:20%; border-right:1px solid #ddd!important; border-bottom:0px solid #ddd;">' + hsn + ' </td>';
                                content = content + '<td style="width:15%; border-right:1px solid #ddd!important; border-bottom:0px solid #ddd; font-weight: ' + font + '; ">' + qun + ' </td>';
                                content = content + '<td style="width:15%; border-right:1px solid #ddd!important; border-bottom:0px solid #ddd;">' + rate + ' </td>';
                                content = content + '<td style="width:15%; border-right:1px solid #ddd!important; border-bottom:0px solid #ddd;">' + per + '</td>';
                                content = content + '<td style="width:10%; border-right:1px solid #ddd!important; border-bottom:0px solid #ddd; font-weight: ' + font + ';">' + amt + ' </td>';
                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content).show();
                            tr.addClass('shown');
                            // var td = $(this).closest('tr');
                        },
                        error: function (data) {
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus1').addClass('summary_minus1');
                $(this).closest('tr').find('.summary_plus1').removeClass('summary_plus1');
            }
        });

    }

    render() {
        return(
            <div className="row tansactionTabs">
                <div className="clearfix"></div>
                <div className="content-tdetails-table table-full-width table-responsive">
                    <table id="MerchantSummaryTable" className="table table-striped table-hover">
                        {/*<tfoot>*/}
                        {/*<tr>*/}
                        {/*    <th>Total:</th>*/}
                        {/*    <th></th>*/}
                        {/*    <th></th>*/}
                        {/*    <th></th>*/}
                        {/*    <th></th>*/}
                        {/*</tr>*/}
                        {/*</tfoot>*/}
                    </table>
                </div>
                <div className="footer">
                    <div className="stats"><i></i>
                    </div>
                </div>
            </div>
        );
    }
}

export default TransactionSummary